"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var checkedIconUrl = require('../../assets/img/checkbox-checked-darkgreen.svg');
var CheckboxWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var CheckboxBtn = (0, styled_components_1.default)('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  padding: 0;\n  min-width: 18px;\n  width: 18px;\n  height: 18px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  ", "\n"], ["\n  display: inline-block;\n  padding: 0;\n  min-width: 18px;\n  width: 18px;\n  height: 18px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  ", "\n"])), function (props) { return props.theme.colors.darkgrey; }, function (props) { return props.theme.colors.cremewhite; }, function (props) { return props.theme.colors.cremewhite; }, function (props) { return props.theme.colors.lightgreen20; }, function (props) {
    return props.active && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      background: url(", ") no-repeat 50%;\n    "], ["\n      border: 1px solid ", ";\n      background: url(", ") no-repeat 50%;\n    "])), function (props) { return props.theme.colors.darkgreen; }, checkedIconUrl);
});
var CheckboxText = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  line-height: 40px;\n  font-family: Montserrat;\n  font-size: 14px;\n  user-select: none;\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  line-height: 40px;\n  font-family: Montserrat;\n  font-size: 14px;\n  user-select: none;\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Checkbox = function (_a) {
    var active = _a.active, children = _a.children, customText = _a.customText, checkboxStyle = _a.checkboxStyle, textStyle = _a.textStyle, clicked = _a.clicked;
    return (react_1.default.createElement(CheckboxWrapper, { onClick: clicked },
        react_1.default.createElement(CheckboxBtn, { active: active, style: checkboxStyle, type: 'button' }),
        react_1.default.createElement(CheckboxText, { style: textStyle }, children),
        customText));
};
Checkbox.propTypes = {
    active: prop_types_1.default.bool,
    children: prop_types_1.default.string,
    customText: prop_types_1.default.element,
    checkboxStyle: prop_types_1.default.object,
    textStyle: prop_types_1.default.object,
    clicked: prop_types_1.default.func
};
exports.default = Checkbox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Checkbox.js.map